import {  Component, NgZone, OnInit, ChangeDetectorRef } from '@angular/core';
import { first, finalize  } from 'rxjs/operators';
import { InsuranceService } from 'src/app/Services/insurance.service';
import swal from 'sweetalert2';
import {AuthService} from "../../auth/AuthService";
import {ProviderService} from "../../Services/provider.service";
import { Router } from '@angular/router';

@Component({
  selector: 'pm-extractor',
  templateUrl: './extractor.component.html',
  styleUrls: ['./extractor.component.css']
})
export class ExtractorComponent implements OnInit {

  selectedFiles: File[] = [];
  isDragOver = false;
  OfficeType: any[] = [];
  selectedOfficeId: number | null = null;
  extractorLogs: any[] = [];
  extractorRunning = false;
  selectedInsurance: string | null = null;
  private clientSub: any;
  selectedDate: string | null = null;
  extractorResult: any = null;
  showExtractorResult = true;
  insuranceOptions = [
  { name: 'Cigna', value: 'CIGNA' },
  { name: 'Metlife', value: 'METLIFE' },
  { name: 'Delta Dental INS', value: 'DELTA_DENTAL_INS' },
  { name: 'Delta Dental Ins Short Form', value: 'DELTA_DENTAL_INS_SHORTFORM' },
  { name: 'Dental Toolkit', value: 'DENTAL_TOOLKIT' },
  { name: 'Dental Xchange', value: 'dentalxchange' },
  { name: 'DHCS', value: 'DHCS' },
  { name: 'Scion', value: 'SCION' },
  { name: 'Liberty Dental', value: 'LIBERTY_DENTAL' },
  { name: 'DENTAQUEST', value: 'DENTAQUEST' },
  { name: 'Medicaid', value: 'MEDICAID' },
  
  ];


  constructor(private insuranceServices: InsuranceService,
              private authService: AuthService,
              private providerServices: ProviderService,
                  private router: Router,
              private ngZone: NgZone,
              private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.loadOfficeData();
    this.clientSub = this.authService.clientIdSubject.subscribe((clientId: number | null) => {
      if (clientId) {
        this.loadOfficeData();
      }
    });
  }
  ngOnDestroy(): void {
    this.clientSub?.unsubscribe();
  }

  loadOfficeData() {
  const params = {
    isOfficeNameAndId: true,
    clientId: this.authService.clientId
  };

  this.providerServices.getAllOffice(params).pipe(first()).subscribe(
    (response: any) => {
      this.ngZone.run(() => {
        this.OfficeType = response || [];
        this.selectedOfficeId = null;

        setTimeout(() => {
          this.cdr.detectChanges();
        });
      });
    },
    () => {
      this.ngZone.run(() => {
        this.OfficeType = [];
        this.selectedOfficeId = null;

        setTimeout(() => {
          this.cdr.detectChanges();
        });
      });
    }
  );
  }

  onFileSelected(event: any) {
  const files: File[] = Array.from(event.target.files || []);
  this.addFiles(files);
  }

onDragOver(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = true;
}

onDragLeave(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = false;
}

onDrop(event: DragEvent) {
  event.preventDefault();
  event.stopPropagation();
  this.isDragOver = false;

  const files: File[] = Array.from(event.dataTransfer?.files || []);
  this.addFiles(files);
}

addFiles(files: File[]) {
  if (!files.length) {
    return;
  }

  this.selectedDate = null;

  const existingFileKeys = new Set(
    this.selectedFiles.map(file => `${file.name}_${file.size}`)
  );

  files.forEach(file => {
    const fileKey = `${file.name}_${file.size}`;

    if (!existingFileKeys.has(fileKey)) {
      this.selectedFiles.push(file);
      existingFileKeys.add(fileKey);
    }
  });
}

removeFile(index: number) {
  this.selectedFiles.splice(index, 1);
}

formatFileSize(bytes: number): string {
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  if (bytes < 1024 * 1024) {
    return `${(bytes / 1024).toFixed(1)} KB`;
  }
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

addLog(message: string, type: 'start' | 'end' | 'info' | 'error') {
  const now = new Date();

  this.extractorLogs.unshift({
    time: now.toLocaleString(),
    message,
    type
  });
}

clearLogs() {
  this.extractorLogs = [];
  this.extractorResult = null;
}

runExtractor() {
  const hasFile = this.selectedFiles.length > 0;
  const hasDate = !!this.selectedDate;
  const clientId = this.authService.clientId;

  if (
    (!hasFile && !hasDate) ||
    !clientId ||
    !this.selectedOfficeId ||
    !this.selectedInsurance
  ) {
    return;
  }

  this.ngZone.run(() => {
    this.extractorRunning = true;

    this.extractorResult = null;
    this.showExtractorResult = true;

    this.addLog(
      `Extractor started for office id ${this.selectedOfficeId}`,
      'start'
    );

    this.cdr.detectChanges();
  });

  this.insuranceServices
    .runExtractor(
      hasFile ? this.selectedFiles[0] : null,
      clientId, // now TypeScript knows this is number
      this.selectedOfficeId!,
      this.selectedInsurance!,
      this.selectedDate
    )
    .subscribe(
      (response: any) => {
        this.ngZone.run(() => {
          this.extractorRunning = false;

          this.extractorResult = {
            totalAccountCount: response?.totalAccountCount || 0,
            validAccountCount: response?.validAccountCount || 0,
            validationErrorCount: response?.validationErrorCount || 0,
            validationErrors: response?.validationErrors || [],
            patients: response?.patients || []
          };

          this.addLog(
            `Extractor completed - Total: ${this.extractorResult.totalAccountCount}, Valid: ${this.extractorResult.validAccountCount}, Validation Errors: ${this.extractorResult.validationErrorCount}`,
            'end'
          );

          if (this.extractorResult.patients.length) {
            this.addLog(
              `${this.extractorResult.patients.length} patient(s) submitted to extractor`,
              'info'
            );
          }

          setTimeout(() => {
            this.cdr.detectChanges();
          });
        });
      },
      (error) => {
        this.ngZone.run(() => {
          this.extractorRunning = false;

          this.addLog(
            error?.error?.message || 'Extractor failed',
            'error'
          );

          setTimeout(() => {
            this.cdr.detectChanges();
          });

          swal.fire({
            title: 'Error!',
            icon: 'error',
            text:
              error?.error?.message ||
              error?.error ||
              'Extractor failed',
            showConfirmButton: false,
            timer: 5000
          });
        });
      }
    );
}

getPatientName(patient: any): string {
  const firstName = patient?.firstName || '';
  const lastName = patient?.lastName || '';

  return `${firstName} ${lastName}`.trim() || '-';
}

getPatientDob(patient: any): string {
  const dob =
    patient?.dob ||
    patient?.dateOfBirth ||
    patient?.patientDob ||
    patient?.birthDate;

  if (!dob) {
    return '-';
  }

  const date = new Date(dob);

  if (isNaN(date.getTime())) {
    return dob;
  }

  return date.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
}

openExtractorReport(): void {
  this.router.navigate(['/extractorReport']);
}

  }
